export const typographyVariantsLarge = {
  display1: {
    // This style should only be leveraged as hero text on display assets such as a banner or poster.
    fontSize: '9.75rem',
    fontWeight: '400', // regular
    lineHeight: '1.25',
  },
  display2: {
    // This style should only be leveraged as hero text on display assets such as a banner or poster.
    fontSize: '6.395rem',
    fontWeight: '400', // regular
    lineHeight: '1.25',
  },
  h1: {
    // Titles appear only on the top of pages and indicate high-level navigation points. Also reserved for titles of modal dialogs.
    fontSize: '4.75rem',
    fontWeight: '800', // extrabold
    lineHeight: '1.25',
  },
  h2: {
    fontSize: '3.375rem',
    fontWeight: '900', // black
    lineHeight: '1.25',
  },
  h3: {
    fontSize: '2.25rem',
    fontWeight: '600', // semibold
    lineHeight: '1.25',
  },
  h4: {
    fontSize: '1.75rem',
    fontWeight: '600', // semibold
    lineHeight: '1.25',
  },
  h5: {
    fontSize: '1.25rem',
    fontWeight: '700', // bold
    lineHeight: '1.25',
  },
  h6: {
    fontSize: '1.25rem',
    fontWeight: '700', // bold
    lineHeight: '1.25',
    textTransform: 'uppercase',
  },
  body1: {
    // Paragraph
    fontSize: '1.25rem', // 20px
    fontWeight: '400', // regular
    lineHeight: '1.5',
  },
  body2: {
    fontSize: '0.875', // 14px
    fontWeight: '400', // regular
    lineHeight: '1.5',
  },
  caption: {
    fontSize: '0.75rem',
    fontWeight: '400', // regular
    lineHeight: '1.5',
  },
  subtitle1: {
    // Legal
    fontSize: '0.688rem',
    fontWeight: '400', // regular
    lineHeight: '1.5',
  },
};

export const typographyVariantsSmall = {
  h1: {
    fontSize: '2rem',
    fontWeight: '500', // medium
    lineHeight: '1.25',
  },
  h2: {
    fontSize: '1.5rem',
    fontWeight: '700', // bold
    lineHeight: '1.25',
  },
  h3: {
    fontSize: '1.375rem',
    fontWeight: '500', // medium
    lineHeight: '1.25',
  },
  h4: {
    fontSize: '1.25rem',
    fontWeight: '500', // medium
    lineHeight: '1.25',
  },
  h5: {
    fontSize: '1.125rem',
    fontWeight: '700', // bold
    lineHeight: '1.25',
  },
  h6: {
    fontSize: '1rem',
    fontWeight: '500', // medium
    lineHeight: '1.25',
    textTransform: 'uppercase',
  },
  body1: {
    // Paragraph
    fontSize: '1rem',
    fontWeight: '400', // regular
    lineHeight: '1.5',
  },
  body2: {
    fontSize: '0.875', // 14px
    fontWeight: '400', // regular
    lineHeight: '1.5',
  },
  caption: {
    fontSize: '0.75rem',
    fontWeight: '400', // regular
    lineHeight: '1.5',
  },
  subtitle1: {
    // Legal
    fontSize: '0.688rem',
    fontWeight: '400', // regular
    lineHeight: '1.5',
  },
};
